/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { Stack } from './Stack.js';

const VStack = /*#__PURE__*/React__default.forwardRef(function VStack(props, ref) {
  return /*#__PURE__*/React__default.createElement(Stack, _extends({}, props, {
    ref: ref,
    orientation: "vertical"
  }));
});

export { VStack };
